import React from 'react';
import { GoArrowUpRight } from "react-icons/go";

const ButtonPage = ({ text, onClick, type = "button", className = "" }) => {
    return (
        <>
            <button
                activeclassname='text-[#2196f3]'
                onClick={onClick}
                className="flex items-center justify-center text-base cursor-pointer text-white bg-[#E91E63] hover:bg-[#183889] px-6 py-3 space-x-3 uppercase font-semibold"
            >
                <span>{text}</span>
                <GoArrowUpRight className="w-6 h-6 text-white font-semibold" />
            </button>
        </>

    );
};

export default ButtonPage;